import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom'
import { axiosInstance } from "../../Config";
import { toast } from "react-toastify";

const UpdateReligious = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [name, setName] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const fetchCitizenship = async () => {
            try {
                const response = await axiosInstance.get(`/getReligious/${id}`);

                if (response.data.success) { 
                    setName(response?.data?.body?.name);  
                }

            } catch (err) {
                setError("Failed to fetch Religious data");
            }
        };

        fetchCitizenship();
    }, [id]);

    useEffect(() => {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = 'auto';

        const backdrops = document.querySelectorAll('.modal-backdrop, .offcanvas-backdrop');
        backdrops.forEach(el => el.remove());
    }, []);



    const handleNameChange = (e) => {
        setName(e.target.value);
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!name.trim()) {
            setError("Religious name is required");
            return;
        }

        try {
            const response = await axiosInstance.post(`/updateReligious/${id}`, {
                name: name.trim()
            });

            if (response.data.success) {
                toast.success('Religious updated successfully');

                setTimeout(() => {
                    navigate('/religiousList');
                }, 1200);
            }

        } catch (err) {
            setError(err?.response?.data?.message || "Failed to update religious. Please try again.");
        }
    };
    return (
        <>
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="title-box mb-3 pb-1">
                                <h4 className="mb-0 page-title">Update Religious</h4>
                                <nav aria-label="breadcrumb" className="mt-1">
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/dashboard" className="new">
                                                <i className="ri-home-4-fill me-1" /> Home
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/religiousList" className="new">
                                                 Religious
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Update Religious
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-lg-12">
                                    <div className="card">
                                        <div className="card-body">
                                            {error && (
                                                <div className="alert alert-danger" role="alert">
                                                    {error}
                                                </div>
                                            )}

                                            <form onSubmit={handleSubmit}>
                                                <div className="mb-3">
                                                    <label className="mb-1 fw-medium">Religious Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        value={name}
                                                        onChange={handleNameChange}
                                                        maxLength={50}
                                                        placeholder="Enter Religious name"
                                                        required
                                                    />
                                                    <small className="text-muted">
                                                        Max 50 characters
                                                    </small>
                                                </div>

                                                <div className="text-end mb-2">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary me-2 px-4"
                                                        onClick={() => navigate('/religiousList')}
                                                    >
                                                        Cancel
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className="btn btn-danger px-4"
                                                    >
                                                        Update Religious
                                                    </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpdateReligious
